import { render, staticRenderFns } from "./ContentViewer.vue?vue&type=template&id=06df1ea1"
import script from "./ContentViewer.vue?vue&type=script&lang=ts"
export * from "./ContentViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports